import React, { useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { MDBox } from '../../MDBox';
import { MDTypography } from '../../MDTypography';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../../config/msalConfig';

export default function OAuthCallback() {
  useEffect(() => {
    // Initialize MSAL
    const msalInstance = new PublicClientApplication(msalConfig);
    
    // Handle the redirect response
    msalInstance.handleRedirectPromise()
      .then((response) => {
        // If response is not null, authentication was successful
        if (response) {
          console.log('Authentication successful', response);
          
          // Close the popup window
          if (window.opener) {
            window.opener.postMessage(
              {
                type: 'microsoft-login-success',
                authResult: response
              },
              window.location.origin
            );
          }
          
          // Close the window after a short delay
          setTimeout(() => {
            window.close();
          }, 1000);
        } else {
          // Check for error in URL
          const urlParams = new URLSearchParams(window.location.search);
          const error = urlParams.get('error');
          const errorDescription = urlParams.get('error_description');
          
          if (error) {
            console.error('OAuth Error:', error, errorDescription);
            
            // Send error message to parent window
            if (window.opener) {
              window.opener.postMessage(
                {
                  type: 'microsoft-login-error',
                  error,
                  errorDescription,
                },
                window.location.origin
              );
            }
            
            // Close the window after a short delay
            setTimeout(() => {
              window.close();
            }, 3000);
          }
        }
      })
      .catch((error) => {
        console.error('Error during redirect handling:', error);
        
        // Send error message to parent window
        if (window.opener) {
          window.opener.postMessage(
            {
              type: 'microsoft-login-error',
              error: 'authentication_failed',
              errorDescription: error.message,
            },
            window.location.origin
          );
        }
        
        // Close the window after a short delay
        setTimeout(() => {
          window.close();
        }, 3000);
      });
  }, []);

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      p={3}
    >
      <CircularProgress />
      <MDTypography variant="h6" mt={2}>
        Completing authentication...
      </MDTypography>
    </MDBox>
  );
}
